import { styled } from "@mui/material/styles";
import { Box, Button, Typography, IconButton } from "@mui/material";

export const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  padding: "24px",
  background: "#fff",
  borderRadius: "0",
});

export const ProductHeader = styled(Box)({
  display: "flex",
  gap: "24px",
  alignItems: "flex-start",
  padding: "0",
  border: "none",
  background: "transparent",
});

export const ImageContainer = styled(Box)({
  position: "relative",
  width: 250,
  height: 250,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const ProductImageLarge = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain",
  borderRadius: "6px",
  border: "none",
  background: "#fff",
  transition: "transform 0.2s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
});

export const CarouselButton = styled(IconButton)(({ left, right }) => {
  const position = left ? { left: 8 } : right ? { right: 8 } : { left: 8 };
  return {
    position: "absolute",
    ...position,
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "white",
    width: 32,
    height: 32,
    zIndex: 2,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
    "&:disabled": {
      opacity: 0.3,
    },
  };
});

export const ImageCounter = styled(Box)({
  position: "absolute",
  bottom: 8,
  right: 8,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  color: "white",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "0.75rem",
  fontWeight: 600,
  zIndex: 2,
});

export const ExpandedImageOverlay = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.9)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  cursor: "pointer",
});

export const ExpandedImageContainer = styled(Box)({
  position: "relative",
  width: "85vw",
  height: "85vh",
  maxWidth: "1200px",
  maxHeight: "900px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  boxSizing: "border-box",
});

export const ExpandedImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain",
  borderRadius: "8px",
  cursor: "default",
  backgroundColor: "#fff",
});

export const ProductSpecsGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "8px 16px",
  marginTop: "8px",
  "& strong": {
    color: "#222",
  },
});

export const PriceTag = styled(Typography)({
  marginTop: "16px",
  fontSize: "24px",
  fontWeight: 700,
  color: "#015682",
});

export const StockBadge = styled("span")(({ inStock }) => ({
  padding: "3px 8px",
  borderRadius: "4px",
  fontWeight: 600,
  fontSize: "0.85rem",
  color: inStock ? "#017a49" : "#fff",
  background: inStock ? "#eaf8f0" : "#d32f2f",
}));

export const QuantityWrapper = styled(Box)({
  marginTop: "20px",
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const Stepper = styled(Box)({
  display: "flex",
  alignItems: "center",
  border: "1px solid #ccc",
  borderRadius: "4px",
  overflow: "hidden",
  height: 36,
});

export const StepButton = styled(Button)({
  minWidth: 32,
  padding: "0 8px",
  fontSize: "18px",
  borderRadius: 0,
  height: "100%",
  textTransform: "none",
  borderLeft: "1px solid #ccc",
  borderRight: "1px solid #ccc",
});

export const QuantityDisplay = styled(Box)({
  padding: "0 12px",
  minWidth: 32,
  textAlign: "center",
  fontWeight: 500,
});

export const AddButton = styled(Button)({
  textTransform: "none",
  padding: "6px 24px",
  fontWeight: 600,
  background: "#0052cc",
  boxShadow: "none",
  "&:hover": {
    background: "#003f99",
  },
});
